import { createActions } from 'redux-actions';
import { addFlashMessage } from '../Flash';
import api from '../../../api';
import { getErrorMessages } from '../../../shared/helpers';

export const {
  setDayAvailability,
  setWeekAvailability,
  updateDayAvailability,
  setAdvancedDay,
  setAdvancedCheckbox,
  setAdvancedSchedule,
  setAdvancedAvailability,
  updateAdvancedSchedule,
  setInstantBookInfo,
  setInstantBookItem,
} = createActions({
  SET_DAY_AVAILABILITY: weekDay => ({ weekDay }),
  SET_WEEK_AVAILABILITY: weekAvailability => ({ weekAvailability }),
  UPDATE_DAY_AVAILABILITY: weekDay => ({ weekDay }),
  SET_ADVANCED_DAY: date => date,
  SET_ADVANCED_CHECKBOX: available => available,
  SET_ADVANCED_SCHEDULE: day => ({ day }),
  SET_ADVANCED_AVAILABILITY: advancedAvailability => ({ advancedAvailability }),
  UPDATE_ADVANCED_SCHEDULE: day => ({ day }),
  SET_INSTANT_BOOK_INFO: instantBookInfo => ({ instantBookInfo }),
  SET_INSTANT_BOOK_ITEM: instantBookItem => ({ instantBookItem }),
});

export const changeDayAvailability = day => dispatch =>
  api
    .updateDayAvailability(day)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(updateDayAvailability(json));
    })
    .catch(() => {
      dispatch(
        addFlashMessage(
          'An error happened when updating your information, please try again',
          'error',
        ),
      );
    });

export const changeAdvancedSchedule = day => dispatch =>
  api
    .updateAdvancedSchedule(day)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(updateAdvancedSchedule(json));
    })
    .catch(() => {
      dispatch(
        addFlashMessage(
          'An error happened when updating your information, please try again',
          'error',
        ),
      );
    });

export const saveDayAvailability = day => dispatch =>
  api
    .saveDayAvailability(day)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(setDayAvailability(json));
    })
    .catch(() => {
      dispatch(
        addFlashMessage(
          'An error happened when saving your information, please try again',
          'error',
        ),
      );
    });

export const fetchWeekAvailability = () => dispatch =>
  api
    .getWeekAvailability()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setWeekAvailability(json));
    })
    .catch(() => {
      dispatch(
        addFlashMessage(
          'An error happened when loading your week information, please try again',
          'error',
        ),
      );
    });

export const saveAdvancedSchedule = day => dispatch =>
  api
    .saveAdvancedSchedule({ ...day, day: day.date })
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(setAdvancedSchedule(json));
    })
    .catch(() => {
      dispatch(
        addFlashMessage(
          'An error happened when saving your information, please try again',
          'error',
        ),
      );
    });

export const fetchAdvancedAvailability = () => dispatch =>
  api
    .fetchAdvancedSchedule()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setAdvancedAvailability(json));
    })
    .catch(() => {
      dispatch(
        addFlashMessage(
          'An error happened when loading your week information, please try again',
          'error',
        ),
      );
    });

export const fetchInstantBookInfo = () => dispatch =>
  api
    .getInstantBookInfo()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setInstantBookInfo(json));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });

export const updateInstantBookInfo = params => dispatch =>
  api
    .updateInstantBookInfo(params)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setInstantBookItem(json));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });



// WEBPACK FOOTER //
// ./src/store/actions/DashboardFreelancer/index.js